/*###########################################################################
// Reveal
//#########################################################################*/

import { throttle } from '../utilities/_throttleDebounce'
import { inViewport } from '../utilities/_inViewport'

const reveal = {
  config: {
    revealEl: '.reveal',
		revealTextEl: '.revealText',
		revealUnderlineEl: '.underline-line--reveal, .underline-wave--reveal, .underline-zigzag--reveal, .underline-slant--reveal',
		revealImage: '.revealImage'
  },

  elements: {
    revealEls: null,
		revealTextEls: null,
		revealUnderlineEls: null,
		revealImages: null,
  },

  init(pageChange) {
    const self = this

    self.elements.revealEls = document.querySelectorAll(self.config.revealEl)

    if (self.elements.revealEls !== null) {
      for (let i = 0; i < self.elements.revealEls.length; i++) {
        const revealEl = self.elements.revealEls[i]
        self.handleRevealEl(revealEl, pageChange)
      }
    }

		self.elements.revealTextEls = document.querySelectorAll(self.config.revealTextEl)

    if (self.elements.revealTextEls !== null) {
      for (let i = 0; i < self.elements.revealTextEls.length; i++) {
        const revealTextEl = self.elements.revealTextEls[i]
        self.handleRevealTextEl(revealTextEl, pageChange)
      }
    }

		self.elements.revealUnderlineEls = document.querySelectorAll(self.config.revealUnderlineEl)

    if (self.elements.revealUnderlineEls !== null) {
      for (let i = 0; i < self.elements.revealUnderlineEls.length; i++) {
        const revealUnderlineEl = self.elements.revealUnderlineEls[i]
        self.handleRevealUnderlineEl(revealUnderlineEl, pageChange)
      }
    }

		self.elements.revealImages = document.querySelectorAll(self.config.revealImage)

		if (self.elements.revealImages !== null) {
      for (let i = 0; i < self.elements.revealImages.length; i++) {
        const revealImage = self.elements.revealImages[i]
        self.handleRevealImage(revealImage, pageChange)
      }
    }
  },

  handleRevealEl(revealEl, pageChange) {
    const self = this

    let dividerValue = 20

    // Check if in viewport already (scroll saved)
    //
    if (inViewport(revealEl, window.innerHeight/dividerValue) && !revealEl.classList.contains('revealed')) {
			if (pageChange) {
				setTimeout(function() {
					revealEl.classList.add('revealed')
				}, 750)
			} else {
				revealEl.classList.add('revealed')
			}
    }

    window.addEventListener('scroll', throttle(function() {
      if (inViewport(revealEl, window.innerHeight/dividerValue) && !revealEl.classList.contains('revealed')) {
        revealEl.classList.add('revealed')
      }
    }, 100))
  },

	handleRevealTextEl(revealTextEl, pageChange) {
    const self = this

    let dividerValue = 20

    // Check if in viewport already (scroll saved)
    //
    if (inViewport(revealTextEl, window.innerHeight/dividerValue) && !revealTextEl.classList.contains('revealedText')) {
			if (pageChange) {
				setTimeout(function() {
					revealTextEl.classList.add('revealedText')
				}, 750)
			} else {
				revealTextEl.classList.add('revealedText')
			}
    }

    window.addEventListener('scroll', throttle(function() {
      if (inViewport(revealTextEl, window.innerHeight/dividerValue) && !revealTextEl.classList.contains('revealedText')) {
        revealTextEl.classList.add('revealedText')
      }
    }, 100))
  },

	handleRevealUnderlineEl(revealUnderlineEl, pageChange) {
    const self = this

    let dividerValue = 20

		const baseClass = revealUnderlineEl.classList[1]

    // Check if in viewport already (scroll saved)
    //
    if (inViewport(revealUnderlineEl, window.innerHeight/dividerValue) && !revealUnderlineEl.classList.contains(baseClass + 'ed')) {
			if (pageChange) {
				setTimeout(function() {
					revealUnderlineEl.classList.add(baseClass + 'ed')
				}, 750)
			} else {
				revealUnderlineEl.classList.add(baseClass + 'ed')
			}
    }

    window.addEventListener('scroll', throttle(function() {
      if (inViewport(revealUnderlineEl, window.innerHeight/dividerValue) && !revealUnderlineEl.classList.contains(baseClass + 'ed')) {
        revealUnderlineEl.classList.add('underline-zigzag--revealed')
      }
    }, 100))
  },

	handleRevealImage(revealImage, pageChange) {
		if (pageChange) {
			setTimeout(function() {
				revealImage.classList.add('revealedImage')
			}, 750)
		} else {
			revealImage.classList.add('revealedImage')
		}
	}
}

initComponent((pageChange) => {
	reveal.init(pageChange)
})
